import React, { memo } from "react"

export const DoubleCheck = () => (
	<svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11.6512 4.66406L4.95559 11.3597L1.91211 8.31624"
			stroke="currentColor"
			strokeWidth="1.1413"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.0876 7.10156L9.52242 11.6668L8.60938 10.7537"
			stroke="currentColor"
			strokeWidth="1.1413"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export default memo(DoubleCheck)
